// pages/messenger/messenger-myjob.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetDataEmail } from '../../components/utils/data-storage';
import RequestService from '../../services/requestService';
import MessengerSidebar from '../../components/common/messenger-sidebar';
import RouteArrow from '../../components/common/route-arrow';
import { TABS } from '../../components/utils/messenger-constants';
import { getBadge, getTab, getTimeLabel } from '../../components/utils/messenger-helpers';
import MessengerService from '../../services/messengerService';

// ── HELPER: เช็คว่า service_date ของ job ตรงกับ "วันนี้" หรือไม่ ──
const isJobToday = (job) => {
    if (!job?.service_date) return false;
    const jobDate = new Date(job.service_date);
    if (Number.isNaN(jobDate.getTime())) return false;
    const today = new Date();
    return (
        jobDate.getFullYear() === today.getFullYear() &&
        jobDate.getMonth() === today.getMonth() &&
        jobDate.getDate() === today.getDate()
    );
};

const MessengerMyJob = () => {
    const navigate  = useNavigate();
    const [activeTab, setActiveTab] = useState('today');
    const [jobs, setJobs]           = useState([]);
    const [loading, setLoading]     = useState(true);
    const [error, setError]         = useState(null);

    useEffect(() => {
        const fetchJobs = async () => {
            setLoading(true);
            try {
                const userEmail = GetDataEmail?.();
                if (!userEmail) return;

                // หา messenger id จาก email ก่อน
                const mesResp = await MessengerService.SearchMessenger({ email: userEmail, status: 1 });
                if (!mesResp?.data?.is_success || !mesResp?.data?.result?.length) {
                    setError('ไม่พบข้อมูล Messenger');
                    return;
                }
                const messengerId = mesResp.data.result[0].id;

                // แล้วค่อย call requests ด้วย id_messenger
                const resp = await RequestService.GetRequests({
                    id_messenger: messengerId,
                    status: 1,
                });

                if (resp?.data?.is_success === true) {
                    setJobs(resp.data.result || []);
                } else {
                    setError('ไม่สามารถโหลดข้อมูลได้');
                }
            } catch (err) {
                console.error('ERROR:', err);
                setError('เกิดข้อผิดพลาด');
            } finally {
                setLoading(false);
            }
        };
        fetchJobs();
    }, []);

    const filteredJobs = jobs
        // .filter(isJobToday)
        .filter((j) => getTab(j) === activeTab)
        .sort((a, b) => {
            // กันค่า null → ดันไปท้ายลิสต์
            if (!a.service_date && !b.service_date) return 0;
            if (!a.service_date) return 1;
            if (!b.service_date) return -1;

            // 1) service_date จากใหม่ → เก่า
            const dateDiff = new Date(b.service_date) - new Date(a.service_date);
            if (dateDiff !== 0) return dateDiff;

            // 2) วันเดียวกัน → ref_no จากมาก → น้อย
            return (b.ref_no || '').localeCompare(a.ref_no || '');
        });;

    return (
        <div className="mmj-root">
            <div className="mmj-header">
                <MessengerSidebar />
                <h1 className="mmj-header-title">งานของฉัน</h1>
            </div>

            <div className="mmj-tabs">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        className={`mmj-tab ${activeTab === tab.key ? 'mmj-tab--active' : ''}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="mmj-content">
                {loading ? (
                    <div className="mmj-empty">
                        <div className="mmj-empty-icon">
                            <i className="mdi mdi-loading mdi-spin" style={{ fontSize: 36, color: '#CBD5E1' }} />
                        </div>
                        <p className="mmj-empty-title">กำลังโหลด...</p>
                    </div>
                ) : error ? (
                    <div className="mmj-empty">
                        <p className="mmj-empty-title">{error}</p>
                    </div>
                ) : filteredJobs.length === 0 ? (
                    <div className="mmj-empty">
                        <div className="mmj-empty-icon">
                            <i className="mdi mdi-archive-alert" />
                        </div>
                        <p className="mmj-empty-title">
                            {activeTab === 'pending' ? 'ไม่มีงานค้าง'
                            : activeTab === 'done' ? 'ยังไม่มีงานที่เสร็จแล้ว'
                            : 'ยังไม่มีงานวันนี้'}
                        </p>
                        <p className="mmj-empty-sub">รอมอบหมายงานหรือรีเฟรชเพื่ออัปเดท</p>
                    </div>
                ) : (
                    <>
                        <p className="mmj-count">ทั้งหมด {filteredJobs.length} งาน</p>
                        <div className="mmj-list">
                            {filteredJobs.map((job) => {
                                const badge = getBadge(job);
                                const time = getTimeLabel(job);
                                const details = job.request_details || [];
                                const from = details[0]?.origin_building_name || '-';
                                const to = details[0]?.destination_company || details[0]?.destination_name || '-';

                                return (
                                    <div
                                        key={job.id}
                                        className={`mmj-card ${badge.type === 'inprogress' ? 'mmj-card--inprogress' : ''}`}
                                        onClick={() => {
                                            if (details.length > 1) {
                                                navigate(`/messenger/job-overview/${btoa(job.id)}`);
                                            } else {
                                                navigate(`/messenger/job-detail/${btoa(job.id)}`);
                                            }
                                        }}
                                    >
                                        <div className="mmj-card-header">
                                            <span className="mmj-ref">Ref No. {job.ref_no}</span>
                                            <span className={`mmj-badge mmj-badge--${badge.type}`}>
                                                {badge.label}
                                            </span>
                                        </div>

                                        <div className="mmj-route">
                                            {details.length > 1 && (
                                                <div className="mmj-round-badge">
                                                    <i className="bx bxs-location-plus" />
                                                    มีส่งมากกว่า 1 ที่
                                                </div>
                                            )}
                                            <div style={{ display: 'flex', width: '100%', alignItems: 'flex-start', gap: 8 }}>
                                                <div className="mmj-route-item">
                                                    <span className="mmj-route-label">ต้นทาง</span>
                                                    <span className="mmj-route-value">{from}</span>
                                                </div>
                                                <RouteArrow /> {/* ✅ shared component */}
                                                <div className="mmj-route-item">
                                                    <span className="mmj-route-label">ปลายทาง</span>
                                                    <span className="mmj-route-value">{to}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mmj-card-footer">
                                            <div className="mmj-txt">
                                                <span className="mmj-route-label">เวลาเสร็จงาน</span>
                                                <span className={`mmj-time mmj-time--${time.type}`}>
                                                    {time.label}
                                                </span>
                                            </div>
                                            <i className="mdi mdi-chevron-right" />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default MessengerMyJob;